import axios from 'axios';

class SettingsService {
    private settings: Settings;
    async getSettings(): Promise<Settings> {
        if (!this.settings) {
            const response = await axios.get<Settings>('/settings.json');
            this.settings = response.data;
        }

        return this.settings;
    }
}

export interface Settings {
    baseUrl: string;
    biLoggingUrl: string;
    isNewContext: boolean;
}

export default new SettingsService();
